module.exports = __webpack_public_path__ + "media/application/images/svgs/shopping-bag-8a3c1a16e44f05ed81fc2b595a62f5af.svg";